import { addErrors, clearCursorWait, clearErrors, setCursorWait, writeMessage } from '../helpers/base';
import { KeydownListener } from '../helpers/keydown_listener';
import { Tooltip } from 'bootstrap';

let turnstileToken = null;
let isTurnstileComplete = false;

// Render Turnstile
window.turnstileCallback = function(token) {
	turnstileToken = token;
	isTurnstileComplete = true;
};

window.turnstileError = function(err) {
	turnstileToken = null;
	isTurnstileComplete = false;

	writeMessage(messageElement, 'Turnstile verification failed. Please try again.', 'error');

	// document.getElementById('turnstile-error').textContent = 'Turnstile verification failed. Please try again.';
	// document.getElementById('turnstile-error').style.display = 'block';
};

const countryCodeElement = document.getElementById('country_code');
const formElement = document.getElementById('form_contact');
const messageElement = document.getElementById('message');
const stateCodeElement = document.getElementById('state_code');
const localizedContactData = typeof contactData !== 'undefined' && contactData ? contactData : {};

function getContactData() {
	if (typeof localizedContactData === 'object' && localizedContactData !== null) {
		return localizedContactData;
	}

	return {};
}

function getContactConfig() {
	const data = getContactData();
	const account = typeof data.account === 'object' && data.account !== null ? data.account : null;
	const inputCountryCode = typeof data.input_country_code === 'string' && data.input_country_code !== '' ? data.input_country_code : 'US';
	const inputState = typeof data.input_state === 'string' ? data.input_state : '';
	const countryCode = typeof account?.country_code === 'string' && account.country_code !== '' ? account.country_code : inputCountryCode;
	const stateCode = typeof account?.state === 'string' ? account.state : inputState;

	return {
		account,
		countryCode,
		stateCode,
		countryStateDataUrl: typeof data.country_state_data_url === 'string' ? data.country_state_data_url : ''
	};
}

function createOption(value, text, selected) {
	const option = document.createElement('option');
	option.value = value;
	option.textContent = text;

	if (selected) {
		option.selected = true;
	}

	return option;
}

function clearElementChildren(element) {
	while (element.firstChild) {
		element.removeChild(element.firstChild);
	}
}

async function loadCountryStateData(countryStateDataUrl) {
	if (countryStateDataUrl === '') {
		throw new Error('country_state_data_url not provided in contactData');
	}

	const response = await fetch(countryStateDataUrl, {
		credentials: 'same-origin'
	});

	if (!response.ok) {
		throw new Error(`Unable to load country/state data (${response.status})`);
	}

	const payload = await response.json();

	if (typeof payload !== 'object' || payload === null || !Array.isArray(payload.countries) || typeof payload.states_by_country !== 'object' || payload.states_by_country === null) {
		throw new Error('Country/state data has an invalid format.');
	}

	return payload;
}

function populateCountrySelect(countrySelect, countries, selectedCountryCode) {
	if (!(countrySelect instanceof HTMLSelectElement)) {
		return;
	}

	const priorityCountryCodes = ['US', 'CA', 'MX'];
	const countryMap = new Map();

	for (const row of countries) {
		if (typeof row?.code === 'string' && row.code !== '' && typeof row?.name === 'string' && row.name !== '') {
			countryMap.set(row.code, row.name);
		}
	}

	clearElementChildren(countrySelect);

	for (const countryCode of priorityCountryCodes) {
		const countryName = countryMap.get(countryCode);

		if (typeof countryName === 'string' && countryName !== '') {
			countrySelect.appendChild(createOption(countryCode, countryName, false));
			countryMap.delete(countryCode);
		}
	}

	const separatorOption = document.createElement('option');
	separatorOption.textContent = '--->';
	separatorOption.disabled = true;
	countrySelect.appendChild(separatorOption);

	const remainingCountries = Array.from(countryMap.entries())
		.map(([code, name]) => ({ code, name }))
		.sort((a, b) => a.name.localeCompare(b.name));

	for (const row of remainingCountries) {
		countrySelect.appendChild(createOption(row.code, row.name, false));
	}

	const hasSelectedCountry = Array.from(countrySelect.options).some((option) => option.value === selectedCountryCode);
	countrySelect.value = hasSelectedCountry ? selectedCountryCode : 'US';
}

function populateStateSelect(stateSelect, statesByCountry, countryCode, selectedStateCode) {
	if (!(stateSelect instanceof HTMLSelectElement)) {
		return;
	}

	clearElementChildren(stateSelect);

	const states = Array.isArray(statesByCountry[countryCode]) ? statesByCountry[countryCode] : [];

	if (states.length === 0) {
		stateSelect.appendChild(createOption('N/A', 'N/A', true));
		stateSelect.disabled = false;
		return;
	}

	stateSelect.appendChild(createOption('', '--->', false));

	for (const row of states) {
		if (typeof row?.code === 'string' && row.code !== '' && typeof row?.name === 'string' && row.name !== '') {
			stateSelect.appendChild(createOption(row.code, row.name, false));
		}
	}

	stateSelect.value = selectedStateCode;
	stateSelect.disabled = false;
}

function setUpCountryState(countrySelect, stateSelect, countryStateData, selectedCountryCode, selectedStateCode) {
	populateCountrySelect(countrySelect, countryStateData.countries, selectedCountryCode);
	populateStateSelect(stateSelect, countryStateData.states_by_country, countrySelect.value, selectedStateCode);

	countrySelect.addEventListener('change', () => {
		populateStateSelect(stateSelect, countryStateData.states_by_country, countrySelect.value, '');
	});
}

function initEventListeners() {
	const btnSubmit = document.getElementById('btn_submit');

	if (!btnSubmit) {
		console.error('Element btn_submit does not exist.');
		return;
	}

	btnSubmit.addEventListener('click', (e) => {
		e.preventDefault();

		submitForm();
	});
}

async function initSection() {
	const config = getContactConfig();

	if (config.account) {
		const account = config.account;
		console.log({ account });

		document.getElementById('first_name').value = account?.first_name ?? '';
		document.getElementById('last_name').value = account?.last_name ?? '';
		document.getElementById('company_name').value = account?.company_name ?? '';

		document.getElementById('email').value = account?.email ?? '';
		document.getElementById('email_confirmation').value = account?.email ?? '';

		document.getElementById('country_code').value = account?.country_code ?? '';
		document.getElementById('state_code').value = account?.state ?? '';

		document.getElementById('phone').value = account?.phone ?? '';
	}

	try {
		const countryStateData = await loadCountryStateData(config.countryStateDataUrl);
		setUpCountryState(countryCodeElement, stateCodeElement, countryStateData, config.countryCode, config.stateCode);
	} catch (error) {
		console.error('Failed to initialize country/state lists.', error);
		writeMessage(messageElement, 'Failed to load country/state options.', 'error');
	}

	const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	tooltipElements.forEach((el) => new Tooltip(el));
}

function setKeyPress() {
	const keyListener = new KeydownListener();

	// Adds listener.
	keyListener.toggle(submitForm);
}

async function submitForm() {
	// Check if Turnstile is complete
	if (!isTurnstileComplete || !turnstileToken) {
		// document.getElementById('turnstile-error').style.display = 'block';
		// document.getElementById('turnstile-error').textContent = 'Please complete the CAPTCHA';

		writeMessage(messageElement, 'Please verify that you are human.', 'error');

		return;
	}

	const formData = new FormData(formElement);
	const formBody = new URLSearchParams(formData).toString();

	try {
		setCursorWait();

		const response = await fetch(`${window.rest_object.url}contact`, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/x-www-form-urlencoded',
				'X-WP-Nonce': window.rest_object.nonce
			},
			body: formBody,
			cache: 'no-cache'
		});

		// console.log('Response status:', response.status);
		// console.log('Response headers:', [...response.headers.entries()]);

		const result = await response.json();

		clearErrors(formElement);

		const { errors, message, status } = result;

		if (status === 'expired') {
			window.location = '/expired';
			return;
		}

		if (errors && typeof errors === 'object') {
			addErrors(formElement, errors);
		}

		if (response.ok && status === 'success') {
			const divEntry = document.getElementById('div_entry');

			if (divEntry) {
				divEntry.style.transition = 'opacity 0.2s ease-out';
				divEntry.style.opacity = '0';

				setTimeout(() => (divEntry.style.display = 'none'), 200);
			}
		}

		writeMessage(messageElement, message, status);
	} catch (error) {
		const { message } = error;

		writeMessage(messageElement, message, 'error');
	} finally {
		clearCursorWait();
	}
}

document.addEventListener('DOMContentLoaded', async function() {
	await initSection();
	setKeyPress();
	initEventListeners();
});
